<template>
	<div class="events-tab p-4">
		<template v-if="!loaded">
			<div class="text-center">
				<icon icon="loading" class="loading-icon"/>
			</div>
		</template>

		<div v-else-if="events.length > 0" class="events-list">
			<div v-for="(event, i) in events" :key="i" class="details-pane-table">
				<hr v-if="i > 0"/>
				<div class="row mb-2">
					<div class="col-4 col-attribute">Event ID:</div>
					<div class="col-8 col-value">{{ event.id }}</div>
				</div>
				<div class="row mb-2">
					<div class="col-4 col-attribute">Date/Time:</div>
					<div class="col-8 col-value" v-html="event.date_and_time"></div>
				</div>
				<div class="row mb-2">
					<div class="col-4 col-attribute">Pricing:</div>
					<div class="col-8 col-value" v-html="event.pricing"></div>
				</div>
				<div class="row mb-2">
					<div class="col-4 col-attribute">Location:</div>
					<div class="col-8 col-value" v-html="event.address"></div>
				</div>
				<div v-if="!!event.contact" class="row mb-2">
					<div class="col-4 col-attribute">Contact:</div>
					<div class="col-8 col-value">
						<a v-if="!!event.contact.email"
							:href="`mailto:${event.contact.email}`"
							class="text-primary">
							{{ event.contact.first_name + " " + event.contact.last_name }}
						</a>
						<span v-else>{{ event.contact.first_name + " " + event.contact.last_name }}</span>
						<span v-if="!!event.contact.phone">
			              <br/>
			              {{ event.contact.phone }}
			            </span>
					</div>
				</div>
				<div class="row">
					<div class="col-12 text-center pt-3">
						<a v-if="!!event.can_enroll"
							class="btn btn-primary mx-1 mb-2"
							@click="enrollMyself(event)">
							Register Myself
						</a>
						<a v-else-if="!!event.can_enroll_error"
							class="btn btn-primary mx-1 mb-2"
							href="#"
							@click.prevent="showError(event.can_enroll_error)">
							Register Myself
						</a>
						<a v-if="!!event.can_enroll_others"
							class="btn btn-primary mx-1 mb-2"
							@click="enrollOthers(event)">
							Register Others
						</a>
						<a
							v-else-if="!!event.can_enroll_others_error"
							class="btn btn-primary mx-1 mb-2"
							href="#"
							@click.prevent="showError(event.can_enroll_others_error)"
						>Register Others</a
						>
					</div>
				</div>
			</div>
		</div>

		<div v-else class="alert alert-info text-center" style="font-size: 12px">
	      <span>No upcoming events are available for this course at this time.</span>
		</div>
	</div>
</template>

<script>
import EnrollmentMixin from "mixins/Events/HandlesEventEnrollment";
export default {
  mixins: [EnrollmentMixin],

	props: {
		course: {type: Object, required: true},
	},

	data() {
		return {
			events: [],
			loaded: false,
		};
	},

	watch: {
		course(model) {
			this.loaded = false;
			this.load();
		},
	},

	methods: {
		load() {
			this.axios
				.get(this.route("catalog.course.events", {course: this.course.id}))
				.then((response) => {
					this.events = response.data || [];
					this.loaded = true;
				});
		},
		showError(msg) {
			this.$modal("AlertModal", {
				alert: {
					type: "danger",
					message: msg,
				},
			})
				.then(() => {
				})
				.catch(() => {
				});
		},
	},

	mounted() {
		this.load();
	},
};
</script>